import { call, put, select } from 'redux-saga/effects';
import { addApplication } from '../../../effects/organization';
import { setBannerAPIRequestState } from '../../../effects/message';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import AnalyticsService from '../../../../services/analytics.service';
import AnalyticsEvents from '../../../../services/analytics.constants';

export default function* createApplication(action) {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const { payload } = action;
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/applications`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.POST,
    body: payload,
  });

  if (!error && success) {
    const { id: appId, uuid, name: appName, creationDate } = result;
    yield put(addApplication({ ...result }));
    if (!payload.hideBanner) {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'success',
          bannerMessage: 'Application has been successfully created!',
        }),
      );
    }
    AnalyticsService.track(AnalyticsEvents.AppCreated, {
      appId,
      uuid,
      appName,
      creationDate,
    });
    return result;
  } else {
    console.error(error);
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage:
          'Something went wrong while creating your application...',
      }),
    );
    return null;
  }
  yield put(
    setBannerAPIRequestState({
      bannerState: 'error',
      bannerMessage: 'Something went wrong while creating your application...',
    }),
  );
  return null;
}
